/* pdfInstruction.js */
import request from "@/tools/request.js";
// import Qs from "qs"


/**
 * 获列表
 * @param {*} params 
 * @returns 
 */
export const getList_api_pdfInstruction = params => request({
    method: 'get',
    url: "pdf-instruction/getList",
    params
});


/**
 * 记录浏览次数
 * @param {*} params 
 * @returns 
 */
export const look_api_pdfInstruction = params => request({
    method: 'get',
    url: "pdf-instruction/look",
    params
});
